var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMergeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48.958,
    height: 50,
    viewBox: "0 0 48.958 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12",
    transform: "translate(-316 -36)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_2",
    "data-name": "Subtraction 2",
    d: "M28.25,31.25H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0H28.25a3,3,0,0,1,3,3V28.25A3,3,0,0,1,28.25,31.25ZM4.125,3.125a1,1,0,0,0-1,1v23a1,1,0,0,0,1,1h23a1,1,0,0,0,1-1v-23a1,1,0,0,0-1-1Z",
    transform: "translate(364.958 86) rotate(180)",
    fill: "#1a286d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_56",
    "data-name": "Path 56",
    d: "M31.9,7.673a.5.5,0,0,0,.146.6Q34.4,10.637,36.772,13c.24.24.24.385,0,.625-.479.479-1.427,1.417-1.906,1.906a.42.42,0,0,0,.1.708.672.672,0,0,0,.208.031H42.3a.417.417,0,0,0,.458-.458V8.683a.424.424,0,0,0-.75-.313l-1.906,1.906c-.24.24-.375.24-.615,0q-2.359-2.344-4.7-4.708a.528.528,0,0,0-.625-.177L31.887,7.673Z",
    transform: "translate(289.02 36.718)",
    fill: "#45539c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_57",
    "data-name": "Path 57",
    d: "M16.2,40.464a.5.5,0,0,0-.146-.6q-2.359-2.359-4.729-4.719c-.24-.24-.24-.385,0-.625.479-.479,1.427-1.417,1.906-1.906a.42.42,0,0,0-.1-.708.672.672,0,0,0-.208-.031H5.791a.417.417,0,0,0-.458.458v7.125a.424.424,0,0,0,.75.313L7.989,37.86c.24-.24.375-.24.615,0q2.359,2.344,4.7,4.708a.528.528,0,0,0,.625.177l2.281-2.281Z",
    transform: "translate(343.157 37.823)",
    fill: "#ff6c00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_3",
    "data-name": "Subtraction 3",
    d: "M28.25,31.251H3a3,3,0,0,1-3-3V3A3,3,0,0,1,3,0h7.417V3.126H4.125a1,1,0,0,0-1,1v23a1,1,0,0,0,1,1h23a1,1,0,0,0,1-1v-23a1,1,0,0,0-1-1H13.541V0H28.25a3,3,0,0,1,3,3v25.25A3,3,0,0,1,28.25,31.251Z",
    transform: "translate(347.25 67.251) rotate(180)",
    fill: "#ff6c00"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMergeIcon);
export default __webpack_public_path__ + "static/media/merge-icon.965aeb4d.svg";
export { ForwardRef as ReactComponent };